// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-black border-t border-neutral-800 py-10 mt-20">
      <div className="mx-auto max-w-7xl px-4 text-center">
        
        {/* Logo */}
        <Link to="/" className="inline-flex justify-center">
          <img
            src="/assets/ulwraps-logo-main.png"
            alt="UL Wraps Logo"
            className="h-10 object-contain opacity-90 hover:opacity-100 transition"
          />
        </Link>

        {/* Nav links */}
        <div className="mt-6 flex flex-wrap justify-center gap-6 text-sm text-neutral-400">
          <Link to="/products" className="hover:text-white transition">Products</Link>
          <Link to="/colors" className="hover:text-white transition">Browse Colors</Link>
          <Link to="/dealer-map" className="hover:text-white transition">Preferred Dealer Map</Link>
          <Link to="/dealersignup" className="hover:text-white transition">Dealer Sign Up</Link>
          <Link to="/gallery" className="hover:text-white transition">Gallery</Link>
        </div>

        {/* Social links */}
        <div className="mt-6 flex justify-center gap-5 text-neutral-400">
          <a
            href="https://www.instagram.com/ULwraps/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-white"
          >
            Instagram
          </a>
          <a
            href="https://www.tiktok.com/@ulwraps"
            target="_blank"
            rel="noreferrer"
            className="hover:text-white"
          >
            TikTok
          </a>
          <a
            href="mailto:info@ulwraps.com"
            className="hover:text-white"
          >
            Email
          </a>
        </div>

        {/* Legal */}
        <p className="mt-8 text-xs text-neutral-500">
          © {new Date().getFullYear()} Unlimited Levels Inc. / UL Wraps - All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
